/**
 * Detects and ignores [Chrome Mobile Fillr](https://www.fillr.com/android-index/) errors.
 *
 * @param {object} report the Report Object
 * @returns {boolean} Returns true if the report matches
 * @example
 *   "AndroidInterface is not defined"
 */
function chromeMobileFillrError(report) {
  if (report.errorMessage.includes("androidInterface is not defined")) {
    report.ignore();

    return true;
  }

  return false;
}

export default chromeMobileFillrError;
